import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { ProductEffects, communityProductReducer } from './community-product';
import { AskEffects, communityAskReducer } from './community-ask';
import { userEffects, userReducer } from './user-details';
import { IndividualProductEffects, individualProductReducer } from './individual-all-product';
import { FilteredCommunityProductEffects, filteredCommunityProductReducer } from './filtered-community-product';
import { BizProductEffects, bizProductReducer } from './biz-product';
import { BizCategoryEffects, bizCategoryReducer } from './biz-category';
import { BizBrandEffects, bizBrandReducer } from './biz-brand';
import { CommunityProductCategoryEffects, communityProductCategoryReducer } from './community-product-category';
import { BizShopProductEffects, bizShopProductReducer } from './biz-shop-product';
import { BizShopBannerEffects, bizShopBannerReducer } from './biz-shop-banner';
import { NewsEffects, newsReducer } from './news';




@NgModule({
  declarations: [],
  imports: [
    CommonModule,// ****** Register feature Reducer
    StoreModule.forFeature('individualProducts', individualProductReducer),
    StoreModule.forFeature('communityProducts', communityProductReducer),
    StoreModule.forFeature('filteredProducts', filteredCommunityProductReducer),
    StoreModule.forFeature('bizProducts', bizProductReducer),
    StoreModule.forFeature('bizShopProducts', bizShopProductReducer),
    StoreModule.forFeature('bizShopBanner', bizShopBannerReducer),
    StoreModule.forFeature('ask', communityAskReducer),
    StoreModule.forFeature('user', userReducer),
    StoreModule.forFeature('bizCategory', bizCategoryReducer),
    StoreModule.forFeature('bizBrand', bizBrandReducer),
    StoreModule.forFeature('communityProductCategory', communityProductCategoryReducer),
    StoreModule.forFeature('news', newsReducer),

    // ****** Register feature effects
    EffectsModule.forFeature([
      ProductEffects,
      IndividualProductEffects,
      BizProductEffects,
      BizShopProductEffects,
      BizShopBannerEffects,
      FilteredCommunityProductEffects,
      AskEffects,
      userEffects,
      BizCategoryEffects,
      BizBrandEffects,
      CommunityProductCategoryEffects,
      NewsEffects
    ]),
  ]
})
export class AppStateModule { }
